var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1054_2412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.78 17.9L24.1762 21.295L14.985 30.4862L5.795 21.2962L9.19125 17.9L14.9863 23.725L20.78 17.9ZM26.5762 12.105L30 15.5L26.6062 18.895L23.21 15.5L26.5762 12.105ZM14.9863 12.105L18.3812 15.47L14.985 18.8662L11.59 15.5L14.985 12.1062L14.9863 12.105ZM3.395 12.105L6.7625 15.5L3.3975 18.865L0 15.5L3.395 12.105ZM14.9875 0.512451L24.1775 9.67495L20.7812 13.0687L14.9863 7.2737L9.1925 13.0987L5.79625 9.7037L14.9863 0.513701L14.9875 0.512451Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1054_2412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinance);
export default __webpack_public_path__ + "static/media/binance.7841ce936bfd2bd59a44212f92de9dd8.svg";
export { ForwardRef as ReactComponent };